import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import router from './router'
import store from './stores/'
import Datetime from 'vue-datetime'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueGtag from 'vue-gtag'
import VCalendar from 'v-calendar'
import IdleVue from 'idle-vue'
import _ from 'lodash'


import 'vue-datetime/dist/vue-datetime.css'
import '@/assets/css/common.scss'
import '@/assets/css/base.scss'
import '@/assets/css/editor.scss'

const eventsHub = new Vue()
Vue.config.productionTip = false
Vue.prototype._ = _ // Vue 인스턴스에 lodash를 사용 가능하게 추가
Vue.use(Datetime)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyD87kW7jzc3vPCMPA6SFTOglRHYvOb6D_o',
    libraries: 'places'
  }
})
Vue.use(VueGtag, {
  config: { id: 'UA-156911706-2' }
})
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 3600000, // 3600 seconds (1hour)
  startAtIdle: false
})
Vue.use(VCalendar, {
  componentPrefix: '' // <DatePicker /> 등 그대로 사용 가능
})
Vue.prototype.$http = axios

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
